import http from 'services/http'
import { httpSemBaseApi } from 'services/http'

import * as R from 'ramda'

import store from 'store'
import { setSession, clearSession } from 'store/actionCreators/session'
import { setMe, logoutMe, setContext as reduxSetContext } from 'store/actionCreators/me'

const dispatch = R.curry((action, ...args) => store.dispatch(action(...args)))

export const redirectByOrigin = origin => {
  window.location.href = origin
}

export const version = async () =>
  await http.get(
    '/authentication/version',
    {},
    {
      headers: {
        accept: 'text/plain;charset=UTF-8'
      }
    }
  )

export const logout = async originDomain => {
  const { ok, data } = await http.put('/authentication/logout')

  if (ok) {
    !originDomain && dispatch(logoutMe)
    dispatch(clearSession)
    !!originDomain
      ? redirectByOrigin(`${originDomain}/auth/login`)
      : redirectByOrigin(`${window.location.origin}/auth/login`)
  }

  return data
}

let ipClient = {}

export const getClientIp = async () => {
  const link1 = await httpSemBaseApi.get(`https://icanhazip.com/`)

  if (link1.ok && link1.data) {
    return { IPv4: link1.data.trim() }
  }

  const link2 = await httpSemBaseApi.get(`https://api.ipify.org/?format=json`)

  if (link2.ok && link2.data && link2.data.ip) {
    return { IPv4: link2.data.ip }
  }

  const link3 = await httpSemBaseApi.get(`https://geolocation-db.com/json/09ba3820-0f88-11eb-9ba6-e1dd7dece2b8`)

  if (link3.ok && link3.data) {
    return link3.data
  }

  return null
}

export const login = async (email, password, system) => {
  const response = await http.post(
    '/authentication',
    {},
    {
      headers: {
        authorization: `Basic ${btoa(`${email.toUpperCase()}:${password.toUpperCase()}`)}`,
        ip: JSON.stringify(ipClient),
        system
      }
    }
  )

  if (response.ok) {
    dispatch(setMe, response.data)
    await session()
  }

  return response
}

export const getContexts = async () => await http.get('/authentication/contexts')

export const me = async () => {
  ipClient = await getClientIp()

  const { ok, data } = await http.post('/authentication', {}, { headers: { ip: JSON.stringify(ipClient) } })

  if (ok) {
    dispatch(setMe, data)
    await session()
  } else {
    dispatch(logoutMe)
  }

  return data
}

export const session = async () => {
  const { ok, data } = await http.get('/contrato/session')

  if (ok) {
    dispatch(setSession, data)
  }

  return data
}
export const onLoadWidgetSuporte = () => {
  const scriptWidget = document.createElement('script')
  const scriptFramework = document.createElement('script')
  const inLineScript = document.createTextNode(
    "window.fwSettings={'widget_id':17000000383};!function(){if('function'!=typeof window.FreshworksWidget)" +
      '{var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()'
  )
  scriptWidget.appendChild(inLineScript)

  scriptFramework.type = 'text/javascript'
  scriptFramework.async = true
  scriptFramework.defer = true
  scriptFramework.src = 'https://widget.freshworks.com/widgets/17000000383.js'
  document.body.appendChild(scriptWidget)
  document.body.appendChild(scriptFramework)
}

export const setContext = async contextId => {
  const { ok, status, data } = await http.put(
    `/authentication/contexts/select/${contextId}`,
    {},
    { headers: { ip: JSON.stringify(ipClient) } }
  )

  if (ok) {
    dispatch(reduxSetContext, data)
  }

  return { ok, status, data }
}

export const getUserDtoInfo = async id => await http.get(`/authentication/user/info/${id}`)

export const forgotPassword = (data, system) =>
  http.post(`/authentication/user/retrieve-pass`, data, {
    headers: {
      system
    }
  })

export const validatePinAndChangePassword = (data, system) =>
  http.post(`/authentication/user/change-password`, data, {
    headers: {
      system
    }
  })

export const redisRefresh = data => http.post(`/authentication/redis-refresh`, data)

export const updateContextConvenioBloqueado = data => {
  dispatch(reduxSetContext, data)
}

export const getTokenObjectStorage = () => {
  return http.get(`/authentication/credentials/object-storage/token`)
}

export default {
  me,
  version,
  login,
  getContexts,
  setContext,
  logout,
  getUserDtoInfo,
  forgotPassword,
  validatePinAndChangePassword,
  getClientIp,
  onLoadWidgetSuporte,
  redisRefresh,
  updateContextConvenioBloqueado,
  getTokenObjectStorage,
  session
}
